import styled from 'styled-components'
import Icon24 from 'builder/components/Icon'

export const Container = styled.div`
  display: flex;
  position: relative;
  flex-flow: column;
`

export const IconChevronDown = styled(Icon24.ChevronDownV2)`
  transition: transform 0.3s ease;
`
